import * as React from 'react';

import { cn } from '../../utils/cn';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const toneStyles: Record<StatusTone, string> = {
  neutral:
    'bg-[color:var(--color-neutral-100)] text-[color:var(--color-neutral-600)] border-[color:var(--color-neutral-200)]',
  info: 'bg-[color:var(--color-primary-50)] text-[color:var(--color-primary-700)] border-[color:var(--color-primary-200)]',
  success:
    'bg-[color:var(--color-success-100)] text-[color:var(--color-success-700)] border-[color:var(--color-success-100)]',
  warning:
    'bg-[color:var(--color-warning-100)] text-[color:var(--color-warning-700)] border-[color:var(--color-warning-100)]',
  danger:
    'bg-[color:var(--color-error-100)] text-[color:var(--color-error-700)] border-[color:var(--color-error-100)]',
};

export const StatusBadge = React.forwardRef<HTMLSpanElement, StatusBadgeProps>(
  ({ tone = 'neutral', icon, children, className, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium uppercase tracking-wide',
        toneStyles[tone],
        className,
      )}
      {...props}
    >
      {icon ? <span className="flex h-3.5 w-3.5 items-center justify-center">{icon}</span> : null}
      <span className="whitespace-nowrap">{children}</span>
    </span>
  ),
);

StatusBadge.displayName = 'StatusBadge';

export default StatusBadge;
